import type { RTG, RTGStatus } from "@/types";

// App constants - extend as needed

/** Capacité maximale de RTG par bloc (SP-03) */
export const MAX_RTG_PER_BLOCK = 6;

/** Garage unique pour RTG en maintenance ou indisponibles (SP-04) */
export const GARAGE_BLOCK_NAME = "Bloc Charlie";
export const GARAGE_SUB_BLOCK_NAME = "Charlie 3";

/** Statuts autorisant l'affectation d'un opérateur (SP-08). Machines indisponibles exclues des listes. */
export const RTG_AVAILABLE_FOR_OPERATOR_STATUSES: RTGStatus[] = [
  "operational",
  "transit",
];

/** Indique si une machine peut recevoir une affectation opérateur (SP-08). */
export function isRTGAvailableForOperator(rtg: RTG): boolean {
  return RTG_AVAILABLE_FOR_OPERATOR_STATUSES.includes(rtg.status);
}

export const ROUTES = {
  AUTH: {
    LOGIN: "/auth/login",
  },
  DASHBOARD: "/dashboard",
  HISTORY: "/history",
  NOTIFICATIONS: "/notifications",
  RTG_MANAGEMENT: "/rtg-management",
  RTG_CRUD: "/rtg-crud",
  SETTINGS: "/settings",
  SUB_BLOCK_PRIORITY: "/sub-block-priority",
} as const;
